import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core'
import { Tabs } from 'foundations-library/components'

const useStyles = makeStyles(theme => {
    const { colors } = theme['foundations-library']

    return {
        numberTypeFilter: {
            width: '100%'
        },
        tabs: {
            backgroundColor: `${colors.neutral[50]} !important`,
            width: 'min(500px, 100%) !important',
            margin: 'auto',
            '& .tab': {
                backgroundColor: 'transparent',
                color: colors.neutral[900],
                border: 'none',
                cursor: 'pointer'
            },
            '& .tab.active--tab': {
                backgroundColor: colors.neutral[900],
                color: '#fff'
            }
        }
    }
})

const local = 'Local'
const tollFree = 'Toll Free'

const tabs = {
    localNumbers: {
        text: local
    },
    tollFreeNumbers: {
        text: tollFree
    }
}

/**
 *
 */
export interface NumberTypeMap {
    [numberType: string]: boolean;
}

interface NumberTypeFilterProps {
  numberTypesEnabled: NumberTypeMap;
  onChange: (updatedNumberTypesEnabled: NumberTypeMap) => void;
  disabled: boolean;
  className?: string;
}

/**
 *  Multi-select style filter allowing the user to choose which types of numbers to search for.
 */
const NumberTypeFilter = ({ numberTypesEnabled, onChange, disabled, className }: NumberTypeFilterProps): JSX.Element => {
    const [activeTab, setActiveTab] = useState(local)
    const classes = useStyles({ disabled })

    const changeNumberTypesEnabld = values => {
        onChange(values)
    }

    const changeToLocal = () => {
        if (!numberTypesEnabled.local) {
            changeNumberTypesEnabld({ local: true, toll_free: false }) // eslint-disable-line @typescript-eslint/naming-convention
        }
    }

    const changeToTollFree = () => {
        if (!numberTypesEnabled.toll_free) {
            changeNumberTypesEnabld({ local: false, toll_free: true }) // eslint-disable-line @typescript-eslint/naming-convention
        }
    }

    const onSwitchChanged = (value: string) => {
        if (disabled) return
        setActiveTab(value)
        value === local ? changeToLocal() : changeToTollFree()
    }

    return (
        <div data-testid="number-type-filter" className={`${classes.numberTypeFilter} ${className}`}>
            <Tabs
                value={activeTab}
                onChange={onSwitchChanged}
                className={classes.tabs}
                items={Object.entries(tabs).map(([key, { text }]) => ({ value: text, text }))}
                data-testid='number-picker-tabs'
            />
        </div>
    )
}

export default NumberTypeFilter
